module.exports = __webpack_public_path__ + "static/photo-009770c815ea0f3d8c1f456d39211dd8.jpg";